import styled from 'styled-components';

// Devices page container styles
export const StyledContainer = styled.div`
    display: flex;
    height: 100%;
    max-width: 100%;
`;

export const StyledMiddleContainer = styled.div<{height?: string}>`
    height: ${props=> props.height? props.height : '90%'};
    width: 75%;
`;

export const StyledRightContainer = styled.div`
    border-left: 1px solid #AAA;
    height: 100%;
    width: 25%;
`;

export const StyledToggleContainer = styled.div`
    width: 100%;
    margin: 0 auto;
    padding: 25px 50px 15px 0 ;
    color: #333;
    display: flex;
    justify-content: flex-end;
`

export const StyledPopupModal = styled.div`
    position: absolute;
`

export const StyledPopUpBox = styled.div`
    position: fixed;
    background: #00000050;
    width: 100%;
    height: 100%;    
    top: 0;
    left: 0;
`
export const StyledBox = styled.div`
    position: relative;
    width: 500px;
    margin: 0 auto;
    height: 225px;
    max-height: 90vh;
    margin: 10% 500px 0 37.5%;    
    background: #fff;
    border-radius: 4px;
    padding: 10px;    
    overflow: auto;
`

// Edit Panel conatiner styles
export const StyledEditPanelContainer = styled.div`
    padding-top: 10px;
`

export const StyledEditActionContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
`
export const StyledEditOverlappingContainer = styled.div`
    width: 90%;
    margin: 0 auto;
    font-size: 16px;
    color: #333;
`

export const StyledSavingModeContainer = styled.div`
    width: 80%;
    margin: 0 auto;
    font-size: 14px;  
    font-family: inherit;
    background: #fff;
    color: #666;
    font-style: italic;
`

export const StyledTitleContainer = styled.div`
    display: flex;
    
    p {
    padding: 8px 0 0 10px;
    }
`


